<div class="card d-flex flex-row align-items-stretch border shadow-sm rounded" style="min-height: 150px">
  <div class="d-flex align-items-center justify-content-center fw-bold fs-1 rounded-start card-total-box"
    [ngClass]="['bg-' + bgColor, 'text-' + textColor]">
    {{ total }}
  </div>

  <div class="flex-grow-1 d-flex flex-column justify-content-between pt-3 pb-3 ps-3 pe-2">
    <div class="fw-bold fs-4 text-center">{{ title }}</div>

    <div class="d-flex flex-wrap justify-content-center align-items-center">
      <it-chip *ngFor="let link of links" [label]="link.label" clickable="true" color="primary"
        class="cursor-pointer me-2" (click)="navigateTo(link)"></it-chip>
    </div>
  </div>
</div>